<template>
  <div class="condition-group">
    <div class="cmp-handle">
      <el-dropdown>
        <span class="el-dropdown-link">
          <i class="el-input__icon el-icon-more"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="handleCmp('delete',componentIndex)"
                            style="text-align: center">删除
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div style="height: 100%">
      <div style="font-size: 16px;font-weight: bold">条件判断</div>
      <el-button class="button" type="primary" size="mini" @click="issueCondition">下发</el-button>
      <el-button class="button" type="primary" style="margin-right:5px" @click="setCondition" size="mini">保存</el-button>
      <a @dragover="allowCondition"
         @drop="(event) => dragToConditionCmp(event, componentIndex)">
        <el-table
            border
            :cell-style="{'vertical-align':'middle'}"
            class="table"
            :data="uDataSources"
            style="width: 100%">
          <el-table-column
              label="状态"
              align="center"
              min-width="75">
            <template slot-scope="scope">
              <el-select v-model="scope.row.rocStatus" placeholder="状态">
                <el-option
                    v-for="(item,index) in rocStatus"
                    :key="index"
                    :label="item"
                    :value="index">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
              label="写入日志"
              align="center"
              min-width="50">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.rocLog"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
              label="持续判断"
              align="center"
              min-width="50">
<!--            header-align="left"-->
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.continuousJudgement"></el-checkbox>
            </template>
          </el-table-column>
<!--          <el-table-column-->
<!--              label="期望结果"-->
<!--              min-width="55">-->
<!--            <template slot-scope="scope">-->
<!--              <el-radio style="display: block" v-model="scope.row.hope" :label="true">True</el-radio>-->
<!--              <el-radio style="display: block" v-model="scope.row.hope" :label="false">False</el-radio>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--              label="期望值"-->
<!--              min-width="85">-->
<!--            <template slot-scope="scope">-->
<!--              <el-input v-model="scope.row.value" placeholder="请输入内容"-->
<!--                        onkeyup="this.value = this.value.replace(/[^\d.]/g,'')"-->
<!--              ></el-input>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column
              label="下限"
              align="center"
              min-width="85">
            <template slot-scope="scope">
              <el-input v-model="scope.row.minError" placeholder="请输入内容"
                        onkeyup="this.value = this.value.replace(/[^\d.]/g,'')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
              label="信号名"
              align="center"
              min-width="150">
            <template slot-scope="scope">
              <span style="margin-right: 15px;font-size:120%"><</span>
              <span>{{scope.row.text}}</span>
              <span style="margin-left: 15px;font-size:120%"><</span>
            </template>
          </el-table-column>
          <el-table-column
              label="上限"
              align="center"
              min-width="85">
            <template slot-scope="scope">
              <el-input v-model="scope.row.maxError" placeholder="请输入内容"
                        onkeyup="this.value = this.value.replace(/[^\d.]/g,'')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
              label="注释"
              min-width="100">
            <template slot-scope="scope">
              <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="请输入内容"
                  maxlength="50"
                  show-word-limit
                  v-model="scope.row.note">
              </el-input>
            </template>
          </el-table-column>
<!--          <el-table-column-->
<!--              label="枚举符号"-->
<!--              min-width="60">-->
<!--            <template slot-scope="scope">-->
<!--              <el-select v-model="scope.row.logic" placeholder="符号">-->
<!--                <el-option-->
<!--                    v-for="(item,index) in logicEnum"-->
<!--                    :key="index"-->
<!--                    :label="item"-->
<!--                    :value="index">-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column
              label="操作"
              align="center"
              min-width="40">
            <template slot-scope="scope">
              <el-button @click="deleteDataSourceItem(scope.row)" icon="el-icon-delete" style="color: #222222"
                         type="text"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import { PROJECT_NODE_TYPE } from '@/common/enums';
import projectDetailAPI from '@/api/projectDetail';

export default {
  name: 'Condition',
  props: {
    itemData: {
      type: Object,
      default() {
        return [];
      },
    },
    componentIndex: {
      type: Number,
    },
  },
  data() {
    return {
      uDataSources: [],
      rocStatus: ['Start', 'Stop', 'Ignore'],
      logicEnum: ['>', '<', '≥', '=', '≤'],
    };
  },
  mounted() {
    setTimeout(() => {
      this.getCondition();
    }, 800);
  },
  computed: {
    ...mapGetters('Engineering', ['getCurCmpStatus']),
    ...mapState('Engineering', ['dragTreeNodeType', 'dragTreeNodeKey']),
    dataSou() {
      return this.itemData.dataSources || [];
    },
  },
  watch: {
    dataSou: {
      handler(newDataSou) {
        const self = this;
        self.uDataSources = newDataSou.map(item => ({
          text: item.text,
          signalKey: item.key,
          rocStatus: '',
          rocLog: false,
          continuousJudgement: false,
          hope: false,
          value: '123',
          maxError: '',
          minError: '',
          note: '',
          logic: 1,
        }));
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapActions('Engineering', ['deleteCpt']),
    ...mapMutations('Engineering', ['addSignalToSingleOutput']),
    handleCmp(command, index) {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      switch (command) {
        case 'delete':
          this.deleteCpt({ index });
          break;
        default:
          break;
      }
    },
    allowCondition(event) {
      event.preventDefault();
      if (this.dragTreeNodeType === PROJECT_NODE_TYPE.DBC_SIGNAL || this.dragTreeNodeType === PROJECT_NODE_TYPE.A2L_MEASURE) {
        event.dataTransfer.dropEffect = 'copy';
      } else {
        event.dataTransfer.dropEffect = 'none';
      }
    },
    dragToConditionCmp(event, componentIndex) {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      // const isExistIndex = this.uDataSources.findIndex(item2 => item2.signalKey === this.dragTreeNodeKey);
      // if (isExistIndex > -1) {
      //   this.$message({
      //     message: '无法拖拽重复的节点',
      //   });
      //   return;
      // }
      const dragNode = JSON.parse(event.dataTransfer.getData('dragNodeData'));
      this.addSignalToSingleOutput({ dragNode, componentIndex });
      setTimeout(() => {
        this.getCondition();
      }, 200);
    },
    /**
     * 删除数据源
     * @param rowData
     */
    deleteDataSourceItem(rowData) {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      console.log(rowData);
      const { componentIndex } = this;
      this.$store.commit('Engineering/deleteDataSource', {
        cptIndex: componentIndex,
        dataSourceKey: rowData.signalKey,
      });
      setTimeout(() => {
        this.getCondition();
      }, 200);
    },
    setCondition() {
      const componentId = this.itemData.cid;
      const signalConditions = this.uDataSources;
      projectDetailAPI.saveConditionConfig(componentId, signalConditions)
        .then(() => {
          this.$message({
            message: '配置保存完成！',
            type: 'success',
          });
        })
        .catch((err) => {
          this.$message.error(`保存失败！${err[1]}`);
        });
    },
    issueCondition() {
      const componentId = this.itemData.cid;
      const signalConditions = this.uDataSources;
      projectDetailAPI.saveConditionConfig(componentId, signalConditions)
        .then(() => {
          projectDetailAPI.issueConditionConfig(componentId)
            .then(() => {
              this.$message({
                message: '配置下发完成！',
                type: 'success',
              });
            })
            .catch((err) => {
              this.$message.error('配置下发失败！');
            });
        })
        .catch((err) => {
          this.$message.error('配置保存失败！');
        });
    },
    getCondition() {
      const componentId = this.itemData.cid;
      projectDetailAPI.getConditionConfig(componentId)
        .then((res) => {
          // console.log(res);
          this.uDataSources.forEach((item) => {
            res.signalConditionDTOS.forEach((config) => {
              if (config.signalKey === item.signalKey) {
                item.continuousJudgement = config.continuousJudgement;
                item.hope = config.hope;
                item.logic = config.logicEnum;
                item.maxError = config.maxError;
                item.minError = config.minError;
                item.note = config.note;
                item.rocLog = config.rocLog;
                item.rocStatus = config.rocordStatusEnum;
                item.value = config.value;
              }
            });
          });
        });
    },
  },
};
</script>

<style scoped lang="scss">
  .button {
    float: right;
    display: flex;
    padding: 12px 20px;
    margin: 20px 0px;
  }

  .table-header {
    width:50px;
    height:25px;
    margin-left:2px;
    margin-right: 2px;
    text-align: center;
    float:left;
  }

  .data-input{
    width: 50px;
    height: auto;
    margin-right: 2px;
    margin-left: 2px
  }

  .condition-group {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 10px;

    .cmp-handle {
      position: absolute;
      top: 0;
      right: 0;

      .el-input__icon {
        line-height: 25px;
      }
    }

    &:hover {
      animation: 1s shadowChange infinite;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/engineering/Condition.vue